import { Box, Typography } from "@material-ui/core";

const toContentBase64 = (file) =>
  new Promise((resolve, reject) => {
    if (file) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    } else {
      resolve(null);
    }
  });

const toContentBinaryContent = (file) => {
  if (file) {
    const reader = new FileReader();
    return reader.readAsArrayBuffer(file);
  } else {
    return null;
  }
};

const getDefaultValueToDisplay = (inputValue) => {
  if (inputValue == undefined || inputValue == null || inputValue === "") {
    return "-";
  }
  return inputValue;
};

const getValueFromTexts = (inputValue, textsObject) => {
  let textValue = "-";
  if (textsObject != undefined && textsObject != null) {
    return textsObject[inputValue];
  }
  return textValue;
};

const buildAuthPayload = (usernameVal, passwordVal) => {
  let authPayload = { username: usernameVal, password: passwordVal };
  return authPayload;
};

const buildPassChangePayload = (
  usernameVal,
  passwordVal,
  passwordKeyVal,
  newPassword1Val,
  newPassword2Val
) => {
  let passChangePayload = {
    username: usernameVal,
    currentPassword: passwordVal,
    passwordKey: passwordKeyVal,
    newPassword1: newPassword1Val,
    newPassword2: newPassword2Val,
  };
  return passChangePayload;
};

const addCreatedAndUpdatedFields = (
  array,
  createdByFn,
  createdAtFn,
  updatedByFn,
  updatedAtFn,
  separator
) => {
  return array.map((item) => ({
    created: `${item[createdAtFn]}${separator}${item[createdByFn]}`,
    updated: `${item[updatedAtFn]}${separator}${item[updatedByFn]}`,
    ...item,
  }));
};

const addCreatedUpdatedPublishedArchivedFields = (
  array,
  createdByFn,
  createdAtFn,
  updatedByFn,
  updatedAtFn,
  publishedByFn,
  publishedAtFn,
  archivedByFn,
  archivedAtFn,
  separator
) => {
  return array.map((item) => ({
    created: `${item[createdAtFn]}${separator}${item[createdByFn]}`,
    updated: `${item[updatedAtFn]}${separator}${item[updatedByFn]}`,
    published: publishedByFn
      ? `${item[publishedAtFn]}${separator}${item[publishedByFn]}`
      : "",
    archived: archivedByFn
      ? `${item[archivedAtFn]}${separator}${item[archivedByFn]}`
      : "",
    ...item,
  }));
};

const addVoteStatisticField = (array) => {
  return array.map((item) => ({
    actionReason: item.votingStatusChange
      ? item.votingStatusChange.reason
      : null,
    statistic: getVotesStatistic(item),
    ...item,
  }));
};

const getVotesStatistic = (item) => {
  if (item.voteOptions) {
    return (
      <Box pl={1}>
        <ul>
          {item.voteOptions.map((option) => {
            return (
              <li key={option.id}>
                <Box display="flex">
                  <Typography component="span" variant="subtitle2">{option.name}:</Typography>{" "}
                  <Typography component="span" variant="subtitle2" color="textSecondary">
                    <b>{getVoteCount(item, option.id)}</b>
                  </Typography>
                </Box>
              </li>
            );
          })}
        </ul>
      </Box>
    );
  }
  return "-";
};

const getVoteCount = (item, votingOptionId) => {
  if (item.votesCount?.length > 0) {
    let votesCountObject = item.votesCount.filter(
      (voteCountObject) => votingOptionId === voteCountObject.votingOptionId
    );
    return votesCountObject?.length > 0 ? votesCountObject[0].votesCount : "-";
  }
  return "-";
};

const addStatusBasedOnBooleanField = (array, field, labels) => {
  return array.map((item) => ({
    status:
      item[field] === true
        ? labels[0]
        : item[field] === false
        ? labels[1]
        : "-",
    ...item,
  }));
};

const addNameFieldForKey = (array, labels) => {
  return array.map((item) => ({
    name: labels[item.key],
    ...item,
  }));
};

const checkAllFieldHasValue = (object, value) => {
  return Object.values(object).every((x) => x === value);
};

const currentUserIsAuthorized = (globalData) => {
  return (
    globalData && globalData.currentUser && globalData.currentUser.isAuthorized
  );
};

const getInitials = (name = "") =>
  name
    .replace(/\s+/, " ")
    .split(" ")
    .slice(0, 2)
    .map((v) => v && v[0].toUpperCase())
    .join("");

const fillMissingTags = () => {
  if (document.getElementsByClassName("MuiSelect-nativeInput")?.length > 0) {
    for (
      let i = 0;
      i < document.getElementsByClassName("MuiSelect-nativeInput").length;
      i++
    ) {
      if (!document.getElementsByClassName("MuiSelect-nativeInput")[i].id) {
        document
          .getElementsByClassName("MuiSelect-nativeInput")
          [i].setAttribute("title", "Niewidoczne, techniczne pole tekstowe");
      }
    }
  }
  if (
    document.getElementsByClassName("MuiInputBase-inputMultiline")?.length > 0
  ) {
    for (
      let i = 0;
      i < document.getElementsByClassName("MuiInputBase-inputMultiline").length;
      i++
    ) {
      if (
        !document.getElementsByClassName("MuiInputBase-inputMultiline")[i].id
      ) {
        document
          .getElementsByClassName("MuiInputBase-inputMultiline")
          [i].setAttribute("title", "Niewidoczne, techniczne pole tekstowe");
      }
    }
  }
};

const cutTextIfTooLong = (text,chars) => {
  return text.length > chars ? text.substring(0, chars) + "..." : text;
}

export {
  toContentBase64,
  getDefaultValueToDisplay,
  getValueFromTexts,
  buildAuthPayload,
  buildPassChangePayload,
  addCreatedAndUpdatedFields,
  addCreatedUpdatedPublishedArchivedFields,
  addVoteStatisticField,
  addStatusBasedOnBooleanField,
  addNameFieldForKey,
  checkAllFieldHasValue,
  currentUserIsAuthorized,
  toContentBinaryContent,
  getInitials,
  fillMissingTags,
  cutTextIfTooLong
};
